"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var UploadDirective = /** @class */ (function () {
    function UploadDirective(element) {
        this.element = element;
        this._queue = null;
        this.onFileSelected = new core_1.EventEmitter();
        this._element = this.element.nativeElement;
    }
    Object.defineProperty(UploadDirective.prototype, "fileUploadQueue", {
        set: function (value) {
            if (value) {
                this._queue = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UploadDirective.prototype, "inputId", {
        set: function (value) {
            this._inputId = value;
        },
        enumerable: true,
        configurable: true
    });
    UploadDirective.prototype.onChange = function () {
        console.log(this._inputId);
        var files = this.element.nativeElement.files;
        this.onFileSelected.emit(files);
        if (this._queue && this._queue.addFiles && files) {
            this._queue.addFiles(files);
        }
        else if (this._queue && this._queue.addFile && files) {
            for (var i = 0; i < files.length; i++) {
                this._queue.addFile(files[i]);
            }
        }
        this.element.nativeElement.value = "";
    };
    UploadDirective.prototype.onDrop = function (event) {
        var files = event.dataTransfer.files;
        this.onFileSelected.emit(files);
        if (this._queue && this._queue.addFiles && files) {
            this._queue.addFiles(files);
        }
        else if (this._queue && this._queue.addFile) {
            for (var i = 0; i < files.length; i++) {
                this._queue.addFile(files[i]);
            }
        }
        event.preventDefault();
        event.stopPropagation();
        this.element.nativeElement.value = "";
    };
    UploadDirective.prototype.onDropOver = function (event) {
        event.preventDefault();
    };
    return UploadDirective;
}());
exports.UploadDirective = UploadDirective;
